<mat-expansion-panel hideToggle>
    <mat-expansion-panel-header>
        <mat-panel-title> This is the expansion title </mat-panel-title>
        <mat-panel-description> This is a summary of the content </mat-panel-description>
    </mat-expansion-panel-header>
    <form class="flex-c" [formGroup]='freeTrialForm'>
        <mat-form-field>
            <mat-label>{{ I18nKeyEnum.NAME | i18n | async }} </mat-label>
            <input [required]="true"
                   [formControl]="nameCtrl"
                   matInput>
            <mat-error
                    *ngIf="nameCtrl.hasError(validatorsErrorEnum.REQUIRED)"
            > {{ I18nKeyEnum.ERROR_NAME_REQUIRED | i18n | async }}
            </mat-error>
        </mat-form-field>
        <div class="flex-r">
            <mat-form-field class="select-country-ct">
                <mat-label>{{ I18nKeyEnum.COUNTRY | i18n | async }}</mat-label>
                <mat-select
                        (selectionChange)="validatePhoneNumber()"
                        id="selectPhoneCountry"
                        [formControl]="countryPrefixCtrl">
                    <mat-select-trigger>
                        <div class="option-wrapper">
                        <span class="country-img">
                            <img *ngIf="!!countryPrefixCtrl.value"
                                 [alt]="countryPrefixCtrl.value.countryCode2"
                                 [src]="countryPrefixCtrl.value.countryCode2 | countryFlagApi"
                                 class="flag-img">
                        </span>
                            <span>
                            {{ countryPrefixCtrl.value.countryPrefix }}
                        </span>
                        </div>
                    </mat-select-trigger>
                    @for (country of countries; track country) {
                        <mat-option [value]="country">
                            <div class="listed-countries">
                                <div class="pref-img">
                                    <img [alt]="country.countryCode2"
                                         [src]="country.countryCode2 | countryFlagApi"
                                         class="flag-img">
                                </div>
                                <div>{{ country.name }}</div>
                                <div class="pref-code">{{ country.countryPrefix }}</div>
                            </div>
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field class="phone-number">
                <mat-label>{{ I18nKeyEnum.NUMBER | i18n | async }}</mat-label>
                <input
                        (blur)="validatePhoneNumber()"
                        maxlength="50"
                        required
                        type="tel"
                        matInput
                        id="callbackPhoneNumber"
                        name="callbackPhonenumber"
                        [formControl]="nationalNumberCtrl"
                >
                <mat-error
                        *ngIf="nationalNumberCtrl.hasError(validatorsErrorEnum.INVALID_NUMBER)"
                >{{ I18nKeyEnum.ERROR_INVALID_NUMBER | i18n | async }}
                </mat-error>
                <mat-error
                        *ngIf="nationalNumberCtrl.hasError(validatorsErrorEnum.REQUIRED)"
                >{{ I18nKeyEnum.ERROR_NUMBER_REQUIRED | i18n | async }}
                </mat-error>
            </mat-form-field>
        </div>
    </form>
</mat-expansion-panel>
